/** Per-type, per-channel notification switches (in-app bell + SMS). */
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Switch } from '../ui/switch';

export function NotificationChannelsCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.request('/me/notification-settings').then(setS).catch(() => {}); }, []);
  const toggle = async (key, channel, value) => {
    const t = s.types.find((x) => x.key === key);
    try {
      setS(await api.request('/me/notification-settings', { method: 'PUT', body: JSON.stringify({ prefs: { [key]: { in_app: t.in_app, sms: t.sms, [channel]: value } } }) }));
    } catch (e) { toast.error(e.message || 'Could not save'); }
  };
  if (!s) return null;
  return (
    <div className="space-y-3 rounded-xl border bg-card p-6" data-testid="notification-channels-card">
      <div><h3 className="text-lg font-semibold">Where we notify you</h3>
        <p className="text-sm text-muted-foreground">Choose the in-app bell, a text message, or both for each kind of update.</p></div>
      {!s.phone_on_file && <p className="rounded-lg bg-amber-50 p-2 text-xs text-amber-900" data-testid="notif-no-phone">Add a mobile number to your profile to receive text messages.</p>}
      <div className="divide-y rounded-lg border">
        <div className="grid grid-cols-[1fr_64px_64px] px-3 py-2 text-[11px] uppercase text-muted-foreground"><span>Update</span><span className="text-center">In-app</span><span className="text-center">SMS</span></div>
        {s.types.map((t) => (
          <div key={t.key} className="grid grid-cols-[1fr_64px_64px] items-center px-3 py-2 text-sm" data-testid={`notif-row-${t.key}`}>
            <span>{t.label}</span>
            <span className="flex justify-center"><Switch checked={t.in_app} onCheckedChange={(v) => toggle(t.key, 'in_app', v)} data-testid={`notif-${t.key}-in_app`} /></span>
            <span className="flex justify-center"><Switch checked={t.sms} onCheckedChange={(v) => toggle(t.key, 'sms', v)} data-testid={`notif-${t.key}-sms`} /></span>
          </div>))}
      </div>
    </div>
  );
}
